import React, { useState, useEffect } from 'react';
import ToggleSwitch from '../../../Components/ToggleSwitch';
import Select, { components } from 'react-select';
import SelectField from '../../../Components/SelectField';
import ReactSelectField from '../../../Components/ReactSelectField';

const PDFTemplateConfig = ({ isEdit, eData, onDataChange, processTypeData, processType }: any) => {
    const [toggles, setToggles] = useState<any>({
        isPDFImageAssignmentEnabled: false,
    });
    const [imageType, setImageType] = useState<any>(null);
    const [statusMarked, setStatusMarked] = useState<any>([]);
    const [isValid, setIsValid] = useState<any>(false);

    const statusOptions = (processType === "Tyre" || processType === "Tire") 
        ? processTypeData?.tyreStatus 
        : processTypeData?.multiStatus;

    useEffect(() => {
        if (isEdit === "task" && eData) {
            const isEnabled = !!(eData?.pdfImageAssignment || eData?.pdfImageAssignmentStatus);
            setToggles({
                isPDFImageAssignmentEnabled: isEnabled,
            });
            setImageType(eData?.pdfImageAssignment ? { label: eData.pdfImageAssignment, value: eData.pdfImageAssignment } : "");
            setStatusMarked(eData?.pdfImageAssignmentStatus ? { label: eData.pdfImageAssignmentStatus, value: eData.pdfImageAssignmentStatus } : "");
        }
    }, [isEdit, eData]);

    useEffect(() => {
        let valid = true;
        if (toggles.isPDFImageAssignmentEnabled) {
            if (!imageType?.value || !statusMarked?.value) {
                valid = false;
            }
        }
        setIsValid(valid);
    }, [toggles.isPDFImageAssignmentEnabled, imageType, statusMarked]);

    useEffect(() => {
        const data = {
            pdfImageAssignment: toggles.isPDFImageAssignmentEnabled ? (imageType?.value || "") : "",
            pdfImageAssignmentStatus: toggles.isPDFImageAssignmentEnabled ? (statusMarked?.value || "") : "",
            isValid: isValid
        };
        onDataChange(data);
    }, [toggles.isPDFImageAssignmentEnabled, imageType, statusMarked, isValid]);

    const handleToggleChange = (key: string, value: boolean) => {
        setToggles((prev: any) => ({ ...prev, [key]: value }));
        if (!value) {
            setImageType(null);
            setStatusMarked(null);
        }
    };

    const imageTypeOptions = [
        { label: "LEFT SIDE", value: "LEFT SIDE" },
        { label: "FRONT", value: "FRONT" },
        { label: "RIGHT SIDE", value: "RIGHT SIDE" },
        { label: "TOP", value: "TOP" },
        { label: "REAR", value: "REAR" },
        { label: "FLOOR", value: "FLOOR" },
    ];

    return (
        <div className="row ms-1 me-2">
            <div className="bg-gray p-3">
                <label className="mb-2">PDF Image Assignment</label>
                <div className="col-md-12">
                    <ToggleSwitch
                        checked={toggles.isPDFImageAssignmentEnabled}
                        onChange={(value: any) => handleToggleChange("isPDFImageAssignmentEnabled", value)}
                        label="Enable task assignment to PDF image"
                    />
                    
                    {toggles.isPDFImageAssignmentEnabled && (
                        <div className="row ms-2 mt-3 d-flex align-items-center">
                            <div className="col-md-3">
                                <SelectField
                                    name="pdfImageAssignment"
                                    placeholder="Select Image Type"
                                    value={imageType?.value || ""}
                                    onChange={(e: any) => setImageType({ label: e.target.value, value: e.target.value })}
                                    className="form-select"
                                >
                                    <option value="" disabled>Select</option>
                                    {imageTypeOptions.map((opt) => (
                                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                                    ))}
                                </SelectField>
                                {!imageType?.value && <small className="text-danger fst-italic">Image Type is required</small>}
                            </div>
                            <div className="col-md-3 text-center mb-2">
                                <span className="">When status is marked as</span>
                            </div>
                            <div className="col-md-3">
                                <SelectField
                                    name="pdfImageAssignmentStatus"
                                    placeholder="Select Status"
                                    value={statusMarked?.value || ""}
                                    onChange={(e: any) => setStatusMarked({ label: e.target.value, value: e.target.value })}
                                    className="form-select"
                                >
                                    <option value="" disabled>Select</option>
                                    {statusOptions?.map((opt: any) => (
                                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                                    ))}
                                </SelectField>
                                {!statusMarked?.value && <small className="text-danger fst-italic">Status is required</small>}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PDFTemplateConfig;
